import { BaseInputBindingsOptions, EntityFormResult, ValueHandlersResult } from '../types';

export const getValueTransformers = <T>(hook: EntityFormResult<T>, options?: BaseInputBindingsOptions): ValueHandlersResult<T> => {
  return {
    toInput: (path) => (options?.transformToInput ? options.transformToInput(hook.getFieldValue(path)) : hook.getFieldValue(path)),
    toState: (path, value) => hook.setFieldValue(path, options?.transformToState ? options.transformToState(value) : value),
  };
};
